<template>
  <section :id="formatedId(content.title[0].text)" data-aos="fade-up" data-aos-once="true">
    <Wrapper :class="$style.inner">
      <Title :title-params="content.title" is-extra-title :class="$style.title" />
      <ul :class="$style.list">
        <li v-for="(item, itemIndex) in items" :key="itemIndex" :class="$style.item">
          <div :class="$style.header">
            <PImage :image-object="item.logo" :class="$style.logo" />
            <p :class="$style.logoTitle">{{ item.logo_title }}</p>
          </div>
          <p :class="$style.desc">{{ item.description }}</p>
          <div :class="$style.codeContainer">
            <p :class="$style.offer">{{ item.offer }}</p>
            <p v-if="isLoggedIn" :class="$style.code">{{ item.code_text }}</p>
          </div>
          <PLink v-if="isLoggedIn" :link-object="item.link_url" is-highlight color="bluko" :class="$style.link">
            {{ item.link_text }}
          </PLink>
          <PLink v-else :simple-url="getOnboardingLink()" is-highlight color="bluko" :class="$style.link">
            {{ item.onboarding_link_text }}
          </PLink>
        </li>
      </ul>
    </Wrapper>
  </section>
</template>

<script>
import Title from '~/components/Title'
import PLink from '~/components/PLink'
import { getOnboardingLink } from '~/mixins/getOnboardingLink'

export default {
  name: 'CardsList',

  components: {
    Title,
    PLink,
  },

  mixins: [getOnboardingLink],

  props: {
    slice: {
      type: Object,
      default: () => ({}),
    },

    isLoggedIn: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    content() {
      return this.slice.primary
    },

    items() {
      return this.slice.items
    },
  },

  methods: {
    formatedId(name) {
      return name.toLowerCase().split(' ').join('-')
    },
  },
}
</script>

<style lang="scss" module>
.title {
  padding-top: 128px;

  text-align: center;
}
.list {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 24px;
  margin-top: 24px;

  @include above(small) {
    grid-template-columns: repeat(2, 1fr);
  }

  @include above(medium) {
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
  }
}

.item {
  padding: 24px;
  border: 2px solid $gray-100;
  border-radius: 8px;

  text-align: center;

  transition: all 0.3s ease-in-out;
  @include above(medium) {
    padding: 24px 40px;
  }
  &:hover {
    box-shadow: 0 0 15px $gray-200;
    transform: translateY(-2px);
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 40px;
  height: 40px;
  margin-right: 12px;
  border-radius: 8px;
  object-fit: contain;
  object-position: center;
}

.logoTitle {
  @include typo-headline;
  font-weight: 500;
}

.desc {
  margin-top: 16px;

  @include typo-sub-text;
}

.offer {
  @include typo-headline;
}

.code {
  margin-top: 4px;

  @include typo-sub-text;
  color: $gray-500;
}

.codeContainer {
  position: relative;

  padding: 16px 0;

  &:before,
  &:after {
    position: absolute;
    left: 50%;

    width: 64px;
    height: 1px;

    background-color: $gray-100;

    content: '';
  }

  &:before {
    top: 0;

    transform: translate(-50%, -100%);
  }
  &:after {
    bottom: 0;

    transform: translate(-50%, 100%);
  }
}

.codeContainer,
.link {
  margin-top: 24px;
}
</style>
